<template>
  <div class="d-flex filter-block">
    <div class="form-search w-20">
      <input type="text" class="mb-4 search-input" v-model="searchQuery" placeholder="Référence ou nom produit" />
      <button class="btn btn-search"><i class="ti ti-search"></i></button>
    </div>
    <!-- Only show animal and gamme filters on /dashboard/products -->
   <template v-if="isProductsRoute">
  <div class="search-filter custom-select-wrapper w-20 mx-2">
    <select v-model="filter_type_animal" @change="onTypeChange" class="custom-select mx-2">
      <option value="">Type d'animal</option>
      <option v-for="(taxon, index) in taxons" :value="taxon.code" :key="index">
        {{ taxon.DisplayName }}
      </option>
    </select>
    <span class="custom-arrow font-16"><i class="ti ti-angle-down"></i></span>
  </div>
      <div class="search-filter custom-select-wrapper w-20 mx-2">
        <select 
          v-model="filter_gamme" 
          @change="onGammeChange" 
          @focus="isGammeOpen = true" 
          @blur="isGammeOpen = false; resetGammePlaceholder()"
          class="custom-select mx-2"
         
        >
          <option value="" disabled>
            {{ isGammeOpen ? 'Veuillez sélectionner un type animal' : 'Gamme' }}
          </option>
          <template v-if="filteredGamme.length > 0">
            <option v-for="(gamme, ind) in filteredGamme" :value="gamme.code" :key="ind">
              {{ gamme.name }}
            </option>
          </template>
        </select>
        <span class="custom-arrow font-16"><i class="ti ti-angle-down"></i></span>
      </div>
    </template>
    <div class="search-filter custom-select-wrapper w-20 mx-2" v-if="isProductsRoute">
      <select v-model="order_by" @change="onSortByChange" class="custom-select mx-2">
        <option value="">Trier</option>
        <option value="AlphaAsc">Ordre alphabétique asc</option>
        <option value="AlphaDesc">Ordre alphabétique desc</option>
        <option value="PriceAsc">Prix moins cher</option>
        <option value="PriceDesc">Prix plus cher</option>
      </select>
      <span class="custom-arrow font-16"><i class="ti ti-angle-down"></i></span>
    </div>
  </div>

  <div v-if="(HasSearch || searchQuery) && isProductsRoute" class="search-result d-flex justify-content-between">
    <p class="mb-0" v-if="!loadingproducts">{{ displayedProductsCount }} résultats pour vos critères.</p>
    <div class="d-flex align-items-center">
      <span class="blue-link cursor-pointer me-4" @click.prevent="SaveFilter"
        ><i class="ti ti-save pe-2"></i>Sauvegarder mon filtre</span
      >
      <span class="blue-link cursor-pointer" @click.prevent="DeleteFilter">
        <i class="ti ti-trash pe-2"></i>Supprimer le filtre
      </span>
    </div>
  </div>
  <div v-else-if="HasSearch || searchQuery" class="search-result d-flex justify-content-between">
    <p class="mb-0" v-if="!loadingproducts">{{ displayedProductsCount }} résultats pour vos critères.</p>
  </div>

  <div v-if="loadingFilter" class="spinner-container bg-light">
    <div class="spinner"></div>
  </div>
  <div v-else-if="paginatedProducts.length>0" class="product-list row mt-0">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" v-for="product in paginatedProducts" :key="product.id">
      <ProductCard :product="product" />
    </div>
  </div>
  <div v-else class="empty">{{ $t("products.empty") }}</div>

  <!-- Pagination Controls -->
  <div v-if="totalProducts > itemsPerPage" class="pagination mt-4 d-flex justify-content-center align-items-center">
    <button @click="previousPage" :disabled="currentPage === 1" class="pagination-btn prev">
      <i class="ti ti-angle-left"></i>
    </button>
    <div class="pagination-content">
      <div class="pagination-btns mt-4">
        <template v-if="totalPages <= 12">
          <button
            v-for="page in totalPages"
            :key="page"
            @click="goToPage(page)"
            :class="['pagination-btn-numbers', { active: currentPage === page }]"
            class="mx-1"
          >
            {{ page }}
          </button>
        </template>
        <template v-else>
          <button @click="goToPage(1)" :class="['pagination-btn-numbers', { active: currentPage === 1 }]" class="mx-1">
            1
          </button>
          <template v-if="currentPage > 4">
            <span class="pagination-ellipsis">...</span>
          </template>
          <button
            v-for="page in paginationRange"
            :key="page"
            @click="goToPage(page)"
            :class="['pagination-btn-numbers', { active: currentPage === page }]"
            class="mx-1"
          >
            {{ page }}
          </button>
          <template v-if="currentPage < totalPages - 3">
            <span class="pagination-ellipsis">...</span>
          </template>
          <button
            v-for="page in lastThreePages"
            :key="page"
            @click="goToPage(page)"
            :class="['pagination-btn-numbers', { active: currentPage === page }]"
            class="mx-1"
          >
            {{ page }}
          </button>
        </template>
      </div>
      <span class="pagination-info">Sur {{ totalPages }}</span>
    </div>
    <button @click="nextPage" :disabled="currentPage === totalPages" class="pagination-btn next">
      <i class="ti ti-angle-right"></i>
    </button>
  </div>
</template>

<script>
  import ProductCard from "./ProductCard.vue";
  import iconsearch from "@/assets/search.svg";
  import { useGammesStore } from "@/stores/gammesStore";
  import { useProductsStore } from "@/stores/productsStore";
  import { useRegisterStore } from "@/stores/register";
  import { useToast } from "vue-toastification";
  import { useRoute } from "vue-router";

  export default {
    name: "ProductList",
    components: {
      ProductCard,
    },
    props: {
      forcedCode: {
        type: String,
        default: "",
      },
      products: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        iconsearch,
        HasSearch: false,
        searchQuery: "",
        filter_type_animal: "",
        filter_gamme: "",
        order_by: "",
        taxonsStore: null,
        taxons: [],
        productsStore: null,
        register_store: null,
        currentPage: 1,
        itemsPerPage: 12,
        route: useRoute(),
        searchDebounce: null,
        loadingproducts:false,
        isGammeOpen: false,
      };
    },
    computed: {
      isTagSearch() {
        return !!this.route.query.tag;
      },
      displayedProductsCount() {
        return this.productsStore.totalProducts;
      },
      totalProducts() {
        return this.productsStore.totalProducts;
      },
      totalPages() {
        return this.productsStore.totalPages || Math.ceil(this.totalProducts / this.itemsPerPage);
      },
      isProductsRoute() {
        return this.route.path === "/dashboard/products";
      },
      filteredGamme() {
        const selected_gamme = this.taxons.find(gamme => gamme.code == this.filter_type_animal);
        return selected_gamme ? selected_gamme.childrenDetails : [];
      },
      loadingFilter() {
        return this.productsStore.loadingFilter;
      },
      ProductsFilters() {
        return this.productsStore.Products;
      },
      paginatedProducts() {
        return this.ProductsFilters;
      },
      paginationRange() {
        const range = [];
        const start = Math.max(2, this.currentPage - 3);
        const end = Math.min(this.totalPages - 3, this.currentPage + 3);
        for (let i = start; i <= end; i++) {
          range.push(i);
        }
        return range;
      },
      lastThreePages() {
        const range = [];
        const start = Math.max(this.totalPages - 2, 2);
        for (let i = start; i < this.totalPages; i++) {
          range.push(i);
        }
        return range;
      },
    },
    created() {
      this.productsStore = useProductsStore();
      this.taxonsStore = useGammesStore();
      this.register_store = useRegisterStore();
      this.taxonsStore.fetchGammes();
      this.taxons = this.taxonsStore.gammes.slice().sort((a, b) => a.id - b.id);
      this.taxons = this.taxons.map(taxon => {
        switch (taxon.slug) {
          case "gamme-equine":
            taxon.DisplayName = "Chevaux";
            break;
          case "gamme-rurale":
            taxon.DisplayName = "Ruminants";
            break;
          case "animaux-de-compagnie":
            taxon.DisplayName = "Animaux de compagnie";
            break;
        }
        return taxon;
      });

      if (this.forcedCode || this.isTagSearch) {
        this.HasSearch = true;
      }

      if (
        this.isProductsRoute &&
        this.register_store.FilterProducts &&
        (this.register_store.FilterProducts.filter_type_animal || this.register_store.FilterProducts.order_by)
      ) {
        this.HasSearch = true;
        this.filter_type_animal = this.register_store.FilterProducts.filter_type_animal;
        this.filter_gamme = this.register_store.FilterProducts.filter_gamme;
        this.order_by = this.register_store.FilterProducts.order_by;
        this.GetProductsByGamme();
      }
    },
    methods: {
        resetGammePlaceholder() {
        if (this.filter_gamme === '' && this.isGammeOpen) {
          this.isGammeOpen = false;
        }
      },


      
      onTypeChange() {
        this.filter_gamme = "";
        this.currentPage = 1;
        this.GetProductsByGamme();
      },
      onGammeChange() {
        this.currentPage = 1;
        this.GetProductsByGamme();
      },
      onSortByChange() {
        this.currentPage = 1;
        this.GetProductsByGamme();
      },
      async GetProductsByGamme() {

        let code = this.forcedCode || (this.filter_gamme ? this.filter_gamme : this.filter_type_animal);
        let orderBy = "";

        if (this.order_by) {
          switch (this.order_by) {
            case "AlphaAsc": orderBy = "order[translation.name]=asc"; break;
            case "AlphaDesc": orderBy = "order[translation.name]=desc"; break;
            case "PriceAsc": orderBy = "order[price]=asc"; break;
            case "PriceDesc": orderBy = "order[price]=desc"; break;
          }
        }

        const params = {
          page: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          orderBy,
        };
        this.loadingproducts =true;

        if (this.searchQuery) {
          console.log(code,"code param for search")
          await this.productsStore.searchProducts(this.searchQuery, this.currentPage, this.itemsPerPage, code,orderBy);
        } else if (this.isTagSearch) {
          const tag = this.route.query.tag;
          await this.productsStore.fetchProductsByTag(tag, params);
        } else if (code && !this.searchQuery) {
          this.HasSearch = true;
          await this.productsStore.fetchProductsByTaxon(code, params);
        } else {
          this.HasSearch = false;
          await this.productsStore.fetchAllProducts({ page: this.currentPage, itemsPerPage: this.itemsPerPage }, this.searchQuery,code,orderBy);
        }
        this.loadingproducts =false;
      },
      SaveFilter() {
        if (!this.isProductsRoute) return;
        const Filter_data = {
          filter_type_animal: this.filter_type_animal,
          filter_gamme: this.filter_gamme,
          order_by: this.order_by,
        };
        this.register_store.SaveFilterProducts(Filter_data);
        const toast = useToast();
        toast.success("Filter sauvegardé avec succès");
      },
      DeleteFilter() {
        this.filter_type_animal = "";
        this.filter_gamme = "";
        this.order_by = "";
        this.searchQuery = "";
        this.HasSearch = false;
        if (this.register_store && this.register_store.DeleteFilterProducts) {
          this.register_store.DeleteFilterProducts();
        }
        this.GetProductsByGamme();
        const toast = useToast();
        toast.info("Filtre supprimé");
      },
      previousPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.GetProductsByGamme();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;

          this.GetProductsByGamme();

          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      },
      goToPage(page) {
        this.currentPage = page;
        this.GetProductsByGamme();
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },

    watch: {
    searchQuery: {
      handler(newVal) {
        console.log(newVal)
        clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
          this.currentPage = 1;
          this.GetProductsByGamme();
        }, 800);
      },
    },
}
  };
</script>

<style scoped>
  .product-list {
  margin-top: 20px;
  display: -webkit-flex; /* Safari fallback */
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  @supports (-webkit-hyphens:none) and (not (hyphens:none)) { .class { gap: 0 25px; } }
}

 .product-list .col-12,
.product-list .col-sm-6,
.product-list .col-md-4,
.product-list .col-lg-3 {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  box-sizing: border-box;
}

  .form-search {
    position: relative;
  }

  .search-input {
    width: 100%;
    height: 50px;
    font-size: 13px;
    background: #ffffff 0% 0% no-repeat padding-box;
    padding: 0 45px 0 15px;
    border: 3px solid #aeb1ba;
    border-radius: 25px;
    outline: none;
  }

  .custom-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #1e347d;
    cursor: pointer;
    border: 1px solid #1e347d;
    border-radius: 25px;
    height: 50px;
    text-align: center;
    padding: 10px 30px 10px 10px;
    background-color: #fff;
    font-size: 16px;
    width: 100%;
    position: relative;
  }

  .custom-select:focus {
    outline: none;
    border-color: #1e347d;
  }

  .custom-select-wrapper {
    position: relative;
  }

  .custom-arrow {
    font-size: 30px;
    color: #ec621a;
    position: absolute;
    right: 10px;
    top: 0%;
    transform: rotate(0deg);
    pointer-events: none;
  }

  .product-info {
    gap: 15px !important;
  }

  /* Styles pour les filtres sur mobile */
  @media (max-width: 768px) {
    .filter-block {
      flex-direction: column;
      gap: 12px;
      width: 100%;
    }

    .form-search,
    .search-filter {
      width: 100% !important;
      margin: 0 !important;
    }

    .search-input {
      height: 44px;
      font-size: 14px;
      padding: 0 40px 0 12px;
      border-width: 2px;
    }

    .custom-select {
      height: 35px !important;
      font-size: 12px !important;
      padding: 8px 35px 8px 12px !important;
      margin: 0px !important;
    }

    .custom-arrow {
      font-size: 24px;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
    }

    .btn-search {
      position: absolute;
      right: 20px;
      top: 33%;
      transform: translateY(-50%);
      background: none;
      border: none;
      padding: 8px;
    }

    /* Amélioration de l'affichage des résultats de recherche */
    .search-result {
      flex-direction: column;
      gap: 12px;
      align-items: flex-start;
    }

    .search-result .d-flex {
      flex-wrap: wrap;
      gap: 8px;
    }

    .blue-link {
      font-size: 13px;
      white-space: nowrap;
    }

    .blue-link i {
      font-size: 14px;
    }
  }

  /* Styles pour les très petits écrans */
  @media (max-width: 480px) {
    .filter-block {
      gap: 10px;
    }

    .search-input {
      height: 42px;
      font-size: 13px;
      padding: 0 38px 0 10px;
    }

    .custom-select {
      width: 90% !important;
    }

    .custom-arrow {
      font-size: 22px;
      right: 6px;
    }

    /* Ajustement des options des selects pour mobile */
    .custom-select option {
      font-size: 13px;
      padding: 6px;
    }

    .search-result p {
      font-size: 14px;
      line-height: 1.3;
    }

    .blue-link {
      font-size: 12px;
    }
  }

  /* Pour les écrans moyens (tablette) */
  @media (min-width: 769px) and (max-width: 1024px) {
    .filter-block {
      flex-wrap: wrap;
      gap: 15px;
    }

    .form-search,
    .search-filter {
      width: calc(50% - 8px) !important;
      min-width: 200px;
    }
  }
</style>